export default "__VITE_ASSET__BFq9EP6M__"